import { Action, InputType } from '@projectstorm/react-canvas-core';

export default class ZoomCanvasAction extends Action {
  constructor() {
    super({
      type: InputType.MOUSE_WHEEL,
      fire: () => {
      }
    });
  }
}